import * as React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "~/design-system/Button";
import { Spinner } from "~/design-system/Spinner";

type LoadButtonProps = {
  onClick: () => void;
  loading: boolean;
};

const LoadButton = (props: LoadButtonProps) => {
  const { t } = useTranslation();

  if (props.loading) {
    return <Spinner size="large" tone="brandAccent" />;
  }

  return (
    <Button
      variant="ghost"
      onClick={props.onClick}
      dataClovisActionId="load-more-button"
    >
      {t("screens.App.components.LoadButton.label", "Load more")}
    </Button>
  );
};

export { LoadButton };
